module.exports = __webpack_public_path__ + "glyphicons-halflings-regular-3ef91859.32941d6330044744c024.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/bootstrap/glyphicons-halflings-regular-3ef91859.svg
// module id = 396
// module chunks = 2